import React from 'react'

import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'
import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import Overlay from 'components/_new/layout/Overlay/Overlay'
import Text from 'components/_new/typography/Text/Text'

import Buttons from '../Buttons/Buttons'
import HintForPremium from '../HintForPremium/HintForPremium'
import ProductImagesWithName from '../ProductImagesWithName/ProductImagesWithName'

import s from './Mobile.scss'
import messages from '../messages'


const SkincareProductDetailsModalMobile = (props) => {
  const {
    texts: { description }, img, productId, brand, name, upchargePrice, media,
    close, withAddToQueueButton, isFetching, isAllProductsButtonVisible,
    onTryButtonClick, onAllProductsButtonClick,
  } = props

  return (
    <ModalContainer>
      <Overlay onClick={close} />
      <Modal onClose={close}>
        <ContentWithLoader isFetching={isFetching}>
          <ProductImagesWithName {...{ img, productId, media, brand, name, upchargePrice }} />
          {
            Boolean(upchargePrice) && (
              <HintForPremium />
            )
          }
          <Buttons {...{ withAddToQueueButton, isAllProductsButtonVisible, onTryButtonClick, onAllProductsButtonClick }} />
          <div className={s.text}>
            <Text message={messages.about} size="16-24" semibold />
            <Text message={description} muted html />
          </div>
        </ContentWithLoader>
      </Modal>
    </ModalContainer>
  )
}

SkincareProductDetailsModalMobile.defaultProps = {
  texts: {},
}


export default SkincareProductDetailsModalMobile
